import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  // Upload,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
// import { NotificationInfo, UserInfo } from "../../../context";

const MerchantCreateFoodpandaProduct = ({
  open,
  close,
  setLoading,
  getFoodpandaProductList,
  limit,
  productList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  // const [fileList, setFileList] = useState([{}]);

  const handleSaveToProduct = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("limit", limit);
    // formdata.append("image", values.file.file);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/foodpanda-grab/new-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "exceed-limit") {
          rerunNotif("error", "Exceed limit.");
          setTimeout(() => {
            setLoadings(false);
            setLoading(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "Saved to product successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getFoodpandaProductList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  // const handleChange = (info) => {
  //   // console.log(info);
  //   let fileList = [...info.fileList];
  //   fileList = fileList.slice(-1);
  //   // console.log("fileList", fileList);
  //   setFileList(fileList);
  // };

  return (
    <Drawer
      title="Create Product"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-products"
        initialValues={{
          product: "",
          description: "",
          price: "",
          // is_per_piece: selectedIsPcs,
          // has_variant: selectedIsVariant,
        }}
        onFinish={handleSaveToProduct}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          {/* <Form.Item
            name="file"
            rules={[
              {
                required: true,
                message: "Product image required",
              },
            ]}
          >
            <Upload
              beforeUpload={({ fileList: newFileList }) => {
                return false;
              }}
              onChange={handleChange}
              multiple={false}
              listType="picture-card"
              maxCount={1}
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={fileList}
            >
              Upload
            </Upload>
          </Form.Item> */}

          <Form.Item
            name="product"
            label="Product Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set product name" size="large" />
          </Form.Item>

          <Form.Item name="description" label="Product Description">
            <Input placeholder="Set product description" size="large" />
          </Form.Item>

          <Form.Item
            name="product_connection"
            label="Product Link To"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select product to link"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {productList.data.length > 0 ? (
                productList.data.map((data, index) => (
                  <Select.Option value={data.id} key={index}>
                    {data.product}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No product found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="srp"
            label="SRP"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={1}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="0.01"
            />
          </Form.Item>

          <Form.Item
            name="allow_discount"
            label="Allow Discount"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value={0}>No</Select.Option>
              <Select.Option value={1}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantCreateFoodpandaProduct;
